import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import './styles.css';

const App = () => {
    return (
        <>
            <Header />
            <MainContent />
            <Footer />
        </>
    );
};

export default App;